export default __webpack_public_path__ + "static/media/architecture-img-26.954a18be.jpg";